import { SECURE_BROWSER_ERROR } from './secureBrowserActions';

const defaultState = {
    secureBrowserError: null,
};

const secureBrowserReducer = (state = defaultState, action) => {
    switch (action.type) {
    case SECURE_BROWSER_ERROR: {
        return {
            ...state,
            secureBrowserError: action.error,
        };
    }
    default:
        return state;
    }
};

export default secureBrowserReducer;
